import { Role } from "@resamare/models";
import { lazyImport } from "@resamare/ui";
import { ProtectedRoute, useAuth } from "@resamare/widgets-shared";
import { Navigate, Route, Routes } from "react-router-dom";

const { LoginPage } = lazyImport(() => import("../pages"), "LoginPage");
const { LogoutPage } = lazyImport(() => import("../pages"), "LogoutPage");

export function AuthRoutes() {
    const { admin } = useAuth();

    return (
        <Routes>
            {!admin ? <Route element={<LoginPage />} path="/login" /> : null}

            <Route element={<ProtectedRoute allowedRole={Role.ADMIN} />}>
                <Route element={<LogoutPage />} path="/logout" />
            </Route>

            <Route element={<Navigate to="/" />} path="*" />
        </Routes>
    );
}
